import { Logo } from "./Logo";
// import { LoadingSpinner } from "./LoadingSpinner"; // ❌ not used anymore
import { EmailSignupForm } from "./EmailSignupForm";
import { Link } from "react-router-dom";

export const HeroSection = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 pb-24 md:pb-32 relative">
      {/* Background glow effect */}
      <div className="absolute inset-0 bg-gradient-glow opacity-30" />

      {/* Main content */}
      <div className="relative z-10 text-center space-y-6 max-w-4xl mx-auto">
        {/* Logo */}
        <div className="animate-fade-in">
          <Logo animate />
        </div>

        <p className="text-xs text-center text-gray-300 max-w-2xl mx-auto mt-2 leading-relaxed">
          Siimply Trade will be a self-directed trading platform offered by Wealth Management firm Siimply Inc.,
          allowing users to buy and sell U.S. stocks, ETFs, and options. It provides a user-friendly website and app
          to manage investments in a range of U.S.-listed securities. The platform also offers tools for managing a
          trading account, viewing market data, and tracking performance.
        </p>

        {/* Main heading */}
        <div
          className="space-y-3 animate-fade-in-up"
          style={{ animationDelay: "0.3s", animationFillMode: "both" }}
        >
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-white leading-tight">
            We&apos;re building the{" "}
            <span className="bg-gradient-to-r from-brand-sky-blue to-brand-white bg-clip-text text-transparent">
              best website ever
            </span>
          </h1>
          <p className="text-lg md:text-xl text-brand-white/80 max-w-2xl mx-auto">
            and that takes a little time
          </p>
        </div>

        {/* Email signup form */}
        <div
          className="animate-fade-in-up"
          style={{ animationDelay: "0.6s", animationFillMode: "both" }}
        >
          <p className="text-brand-white/80 text-base mb-4">
            Leave your email and we&apos;ll let you know when we go live—no spam, just updates.
          </p>
          <div className="w-full flex justify-center">
            <EmailSignupForm />
          </div>
        </div>

        {/* Secondary message */}
        <div
          className="animate-fade-in-up"
          style={{ animationDelay: "0.9s", animationFillMode: "both" }}
        >
          <p className="text-xl md:text-2xl font-semibold text-brand-sky-blue">
            Get ready to <span className="text-brand-white font-bold">Siimply</span> make tomorrow{" "}
            <span className="text-brand-white font-bold">Better</span>
          </p>
        </div>

        {/* CTA for Charts */}
        <div
          className="animate-fade-in-up"
          style={{ animationDelay: "1.0s", animationFillMode: "both" }}
        >
          <p className="mb-4 opacity-80">While we build something, take a look at our Trading Chart.</p>
          <Link
            to="/charts"
            className="inline-block rounded-md bg-sky-500 hover:bg-sky-600 px-5 py-3 font-medium text-white"
          >
            View Charts
          </Link>
        </div>
      </div> {/* ✅ close the main content wrapper here */}

      {/* Floating elements */}
      <div className="absolute top-1/4 left-10 w-4 h-4 bg-brand-sky-blue rounded-full animate-float opacity-60" />
      <div className="absolute top-1/3 right-20 w-5 h-5 bg-brand-sky-blue rounded-full animate-float opacity-40" style={{ animationDelay: "1s" }} />
      <div className="absolute bottom-1/4 left-1/4 w-3 h-3 bg-brand-sky-blue rounded-full animate-float opacity-80" style={{ animationDelay: "2s" }} />
      <div className="absolute bottom-1/3 right-1/4 w-4 h-4 bg-brand-sky-blue rounded-full animate-float opacity-50" style={{ animationDelay: "1.5s" }} />
      <div className="absolute top-1/5 left-1/3 w-2 h-2 bg-brand-sky-blue rounded-full animate-float opacity-70" style={{ animationDelay: "0.5s" }} />
      <div className="absolute top-2/3 left-16 w-3 h-3 bg-brand-sky-blue rounded-full animate-float opacity-45" style={{ animationDelay: "2.5s" }} />
      <div className="absolute bottom-1/2 right-1/3 w-4 h-4 bg-brand-sky-blue rounded-full animate-float opacity-65" style={{ animationDelay: "3s" }} />
      <div className="absolute top-3/4 right-12 w-2 h-2 bg-brand-sky-blue rounded-full animate-float opacity-55" style={{ animationDelay: "0.8s" }} />
      <div className="absolute bottom-1/5 left-1/2 w-5 h-5 bg-brand-sky-blue rounded-full animate-float opacity-35" style={{ animationDelay: "1.8s" }} />
      <div className="absolute top-1/2 left-8 w-3 h-3 bg-brand-sky-blue rounded-full animate-float opacity-75" style={{ animationDelay: "2.2s" }} />
    </div>
  );
};
